var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info"},[_c('div',{staticClass:"icon"},[_c('q-avatar',_vm._b({attrs:{"size":"xl"}},'q-avatar',{ icon: _vm.icon, color: _vm.color },false))],1),_c('div',{staticClass:"text"},[_vm._v(" "+_vm._s(_vm.text)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }